import React from "react";
import { Link, useLocation } from "react-router-dom";
import bt1 from "../img/bt1.png";
import bt2 from "../img/bt2.png";
import bt3 from "../img/bt3.png";
import bt4 from "../img/bt4.png";

function MenuButtons() {
    const location = useLocation();


    return (
        <>
            <div className="container-fluid">
                < div className="row">
                    < div className="centerTheMenuButtons col-xl-3 col-md-6 mb-5 mt-2">
                        <Link className="button" to="/savings">
                            <div className={`button ${location.pathname === "/savings" ? "active" : ""}`}>
                                <img src={bt1} alt="Button" />
                                <span className="text-5xl buttonText coloredLetters text-savings text-uppercase">
                                    Savings
                                </span>
                            </div>
                        </Link>
                    </div>
                    < div className="centerTheMenuButtons col-xl-3 col-md-6 mb-5 mt-2">
                        <Link className="button" to="/jobs">
                            <div className={`button ${location.pathname === "/jobs" ? "active" : ""}`}>
                                <img src={bt2} alt="Button" />
                                <span className="buttonText coloredLetters text-lg  text-jobs text-uppercase mb-1 ">Jobs</span>
                            </div>
                        </Link>
                    </div>
                    < div className="centerTheMenuButtons col-xl-3 col-md-6 mb-5 mt-2">
                        <Link className="button" to="/investments">
                            <div className={`button ${location.pathname === "/investments" ? "active" : ""}`}>
                                <img src={bt3} alt="Button" />
                                <span className="investments coloredLetters text-lg text-investments text-uppercase mb-1">Investments</span>
                            </div>
                        </Link>
                    </div>
                    < div className="centerTheMenuButtons col-xl-3 col-md-6 mb-5 mt-2">
                        <Link className="button" to="/lessons">
                            <div className={`button ${location.pathname === "/lessons" ? "active" : ""}`}>
                                <img src={bt4} alt="Button" />
                                <span className="buttonText coloredLetters text-lg  text-lessons text-uppercase mb-1">Lessons</span>
                            </div>
                        </Link>
                    </div>
                </div>
            </div >

            {/* <div className="container-fluid">
                < div className="row" >
                    < div className="col-xl-3 col-md-6 mb-4">
                        <Link to="/savings" style={{ textDecoration: "none" }}>
                            <div className={`hoveringcard card border-left-primary shadow h-100 py-2 
                            ${location.pathname === "/savings" ? "active" : ""
                                }`}>
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="coloredLetters text-lg  text-success text-uppercase mb-1">
                                                Savings
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-clipboard-list fa-2x text-gray-300" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div >
                    < div className="col-xl-3 col-md-6 mb-4" >
                        <Link to="/jobs" style={{ textDecoration: "none" }}>

                            <div className={`hoveringcard card border-left-primary shadow h-100 py-2 ${location.pathname === "/jobs" ? "active" : ""
                                }`}
                            >
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="coloredLetters text-lg  text-success text-uppercase mb-1">
                                                Jobs to Do
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-clipboard-list fa-2x text-gray-300" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div >
                    < div className="col-xl-3 col-md-6 mb-4" >
                        <Link to="/investments" style={{ textDecoration: "none" }}>
                            <div className={`hoveringcard card border-left-primary shadow h-100 py-2 ${location.pathname === "/investments" ? "active" : ""
                                }`}
                            >                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-lg  text-info text-uppercase mb-1">
                                                Investments
                                            </div>
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto">
                                                </div>
                                                <div className="col">
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-chart-line fa-2x text-gray-300" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div >
                    < div className="col-xl-3 col-md-6 mb-4" >
                        <Link to="/lessons" style={{ textDecoration: "none" }}>

                            <div className={`hoveringcard card border-left-primary shadow h-100 py-2 ${location.pathname === "/lessons" ? "active" : ""
                                }`}
                            >                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-lg  text-warning text-uppercase mb-1">
                                                Lessons
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-lightbulb fa-2x text-gray-300" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div >
                </div >
            </div > */}
        </>
    )
}

export default MenuButtons;